import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall, sinReducerSuccess} from './ajaxStatusActions';

export function getModuloListSuccess(modulo) {
  return {type: types.LOAD_MODULO_LIST_SUCCESS, modulo};
}



export function getModuloList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ModuloApi.getModuloList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(modulo => {                  
                  dispatch(getModuloListSuccess(modulo));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getModulosListSuccess(modulo) {
  return {type: types.LOAD_MODULOSLIST_SUCCESS, modulo};
}

export function getModulosList(idCurso, token) {
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ModuloApi.getModulosList(idCurso, token).then(modulo => {      
                  dispatch(getModulosListSuccess(modulo));
                  return modulo;
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function getModuloSuccess(catalogo) {
  return {type: types.LOAD_MODULO_SUCCESS, catalogo};
}

export function getModulo(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().ModuloApi.getModulo(id, token).then(modulo => {   
        dispatch(getModuloSuccess(modulo));
        return modulo;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}



export function getModuloConfig(id,idCurso=0, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().ModuloApi.getModuloConfig(id, idCurso, token).then(modulo => {   
        dispatch(getModuloSuccess(modulo));
        return modulo;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(modulo) {
  return {type: types.SAVE_MODULO_SUCCESS, modulo};
}


export function save(modulo, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ModuloApi.save(modulo, token).then(moduloGuardado => {   
    dispatch(saveSuccess(moduloGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function saveConfig(modulo, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ModuloApi.saveConfig(modulo, token).then(moduloGuardado => {   
    dispatch(saveSuccess(moduloGuardado));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveModuloCursoOrden(modulos, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ModuloApi.saveModuloCursoOrden(modulos, token).then(modulosGuardado => {   
        
        dispatch(saveSuccess(modulosGuardado));
        
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function saveModuloContenidoOrden(modulos, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().ModuloApi.saveModuloContenidoOrden(modulos, token).then(contenidoGuardado => {   
        
        dispatch(saveSuccess(contenidoGuardado));
        
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getModuloComboSuccess(datos) {
  return {type: types.GET_MODULOS_COMBO_SUCCESS, datos};
}

export function getModuloCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().ModuloApi.getModuloCombo(token).then(datos => {   
        
      dispatch(getModuloComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(modulo) {
  return {type: types.BORRAR_MODULO_SUCCESS, modulo};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ModuloApi.borrar(id, token ).then(modulo => {
               
                  dispatch(borrarSuccess(modulo));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}

export function borrarMC(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ModuloApi.borrarMC(id, token ).then(modulo => {
               
                  dispatch(borrarSuccess(modulo));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(modulo) {
  return {type: types.ACTIVAR_MODULO_SUCCESS, modulo};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().ModuloApi.activar(id, token).then(modulo => {
               
                  dispatch(activarSuccess(modulo));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos,filtrosCombo) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos,
        filtrosCombo
	}
  return {type: types.SET_FILTRO_MODULO, filtro};
}



